import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=3a5f005b&scoped=true"
import script from "./NewReport.vue?vue&type=script&lang=js"
export * from "./NewReport.vue?vue&type=script&lang=js"
import style0 from "./NewReport.vue?vue&type=style&index=0&id=3a5f005b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f005b",
  null
  
)

export default component.exports